(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .directive('sodAppointmentSelectorButton', sodAppointmentSelectorButton);

    const template = `
        <button type="button" class="button default" ng-click="vm.onClick()">Test</button>
    `;

    function sodAppointmentSelectorButton() {
        return {
            scope: {

            },
            template: template,
            controller: sodAppointmentSelectorButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodAppointmentSelectorButtonCtrl(ActionManager) {
        const vm = this;
        this.$onInit = function() {
            vm.onClick = onClick;
        }
        // onClick();

        function onClick() {
            console.log('hello World');
            ActionManager('open-appointment-selector', {}).then(function(result) {
                result.modal.closed.then(function(res) {
                    console.log(res);
                });
            });
        }
    }
})();